import React from 'react';

import Work, { WorkTitle } from './Work.styles';
import ImageSlider from 'components/ImageSlider';

export default props => (
  <Work>
    <ImageSlider images={props.images} prefix={props.name.split(' ').join('-').toLowerCase()} />
    <div className="Work__content">
      <WorkTitle>{props.name}</WorkTitle>
      <ul className="Work__tags">
        {props.tags.map((tag, index) => (
          <li className="Work__tags-tag" key={index}>
            {tag}
          </li>
        ))}
      </ul>
      <div className="Work__description">{props.description}</div>
    </div>
    {props.url && (
      <a className="Work__action" href={props.url} target="_blank">
        View Site
      </a>
    )}
  </Work>
);



// WEBPACK FOOTER //
// ./src/components/Work/Work.js